export default __webpack_public_path__ + "static/button-action-do-dark-7825e89af94411f66e23677aba1688d6.png";